import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const ViewAgendaIcon = ({
  strokeColor = 'currentColor',
  ...props
}: SvgIconProps & { strokeColor?: string }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M17.5 2.5H2.5V8.33333H17.5V2.5Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.5 11.6667H2.5V17.5001H17.5V11.6667Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default ViewAgendaIcon;
